module.exports = __webpack_public_path__ + "img/install-banner.371df896.png";